export default __webpack_public_path__ + "static/media/Member_ChingLinHuang.b30cd318.jpg";